(function () {
	'use strict';
	angular.module('app.setup')
		.controller('configSSO', configSSO);

	configSSO.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', '$compile', 'storeService',
		'tableService', 'leanFilterService', 'tableRenderService', 'configSSOService', 'URLS', '$experiments'];
	function configSSO($scope, $rootScope, $timeout, $uibModal, $compile, storeService,
			tableService, leanFilterService, tableRenderService, configSSOService, URLS, $experiments) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var reportSettingsName = 'ConfigSSO';
		// Extra query params to send to backend in data requests
		var extraParams = [{
		}];
		var rendererParams = {};

		$scope.filterService = leanFilterService;

		vm.showExcel = false;
		vm.isAdmin = $rootScope.authz.isAdmin();
		vm.showAddSamlProfile = vm.isAdmin;
		vm.showAddMetadataSp = vm.isAdmin;
		vm.disableSamlProfile = disableSamlProfile;
		vm.activateSamlProfile = activateSamlProfile;
		vm.deleteSamlProfile = deleteSamlProfile;
		vm.editSamlProfile = editSamlProfile;
		vm.addSamlProfile = addSamlProfile;
		vm.addMetadataSp = addMetadataSp;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'SSO Setup';
		vm.toggleLegacyEntityID = toggleLegacyEntityID;

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		var columns = [
			{
				'id': 'name',
				'display': 'Profile Name',
				'renderer': tableRenderService.title,
				'forceWidth': 200,
				'hideMenu': true,
				'sort': false,
				'show': true
			},
			{
				'id': 'dateCreated',
				'display': 'Creation Date',
				'renderer': tableRenderService.dateTime,
				'forceWidth': 170,
				'hideMenu': true,
				'sort': false,
				'sortDirection': 'desc',
				'show': true
			},
			{
				'id': 'dateExpiry',
				'display': 'Public Key Expires',
				'renderer': tableRenderService.dateTime,
				'forceWidth': 170,
				'hideMenu': true,
				'sort': false,
				'show': true
			},
			{
				'id': 'isActive',
				'display': 'Status',
				'renderer': tableRenderService.yesNoSSOActive,
				'forceWidth': 80,
				'hideMenu': true,
				'sort': false,
				'show': true
			},
			{
				'id': 'actions',
				'display': 'Actions',
				'renderer': tableRenderService.configSSOActionRenderer,
				'forceWidth': 80,
				'hideMenu': true,
				'sort': false,
				'show': true
			}

		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: String.format('companyId/{0}/samlIdpProfile', adminConfig.customer.id),
			noPaging: true,
			columns: columns,
			pinnedColumns: [],
			defaultSort: 'dateCreated',
			defaultSortDirection: 'desc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			setColumnDefaults: true,
			noFactory: true,
			hideColumnSelector: true,
			alternateNoResultText: 'No SAML Idp Profiles exist yet.',
			alternateNoResultSuggest: 'Please add a profile to continue.'
		};

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useAdminFactory = true;
		}

		function closeModal(instance, formScope) {
			instance.close();
			formScope.$destroy();
		}

		function editSamlProfile(samlProfileId) {
			var editSamlProfileFormScope = $scope.$new();
			editSamlProfileFormScope.action = 'Edit';
			editSamlProfileFormScope.customerNdx = adminConfig.customer.id;
			editSamlProfileFormScope.samlProfileId = samlProfileId;
			if (!_.endsWith(globalConfig.user.userName, '@leandna.com')) {
				editSamlProfileFormScope.allowedDomainsReadonly = true;
			} else {
				editSamlProfileFormScope.allowedDomainsReadonly = false;
			}
			var opts = {
				scope: editSamlProfileFormScope,
				templateUrl: '/application/f/setup/configSSO/configSSO-edit-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			editSamlProfileFormScope.closeDialog = function () {
				instance.close();
				editSamlProfileFormScope.$destroy();
			};

			editSamlProfileFormScope.result = function (message, isSuccessful) {
				$rootScope.$emit('toast', { 'message': message, 'success': isSuccessful });
				if (isSuccessful) {
					$scope.$broadcast('reloadTable');
					closeModal(instance, editSamlProfileFormScope);
				}
				if (message === '') {
					closeModal(instance, editSamlProfileFormScope);
				}

			};
			return false;
		}

		function addSamlProfile() {
			var addSamlProfileFormScope = $scope.$new();
			addSamlProfileFormScope.action = 'Add';
			addSamlProfileFormScope.customerNdx = adminConfig.customer.id;
			if (!_.endsWith(globalConfig.user.userName, '@leandna.com')) {
				addSamlProfileFormScope.allowedDomains = globalConfig.user.userName.split('@')[1];
				addSamlProfileFormScope.allowedDomainsReadonly = true;
			} else {
				addSamlProfileFormScope.allowedDomainsReadonly = false;
			}
			var opts = {
				scope: addSamlProfileFormScope,
				templateUrl: '/application/f/setup/configSSO/configSSO-edit-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			addSamlProfileFormScope.closeDialog = function () {
				instance.close();
				addSamlProfileFormScope.$destroy();
			};

			addSamlProfileFormScope.result = function (message, isSuccessful) {
				$rootScope.$emit('toast', { 'message': message, 'success': isSuccessful });
				if (isSuccessful) {
					$scope.$broadcast('reloadTable');
					closeModal(instance, addSamlProfileFormScope);
				}

				if (message === '') {
					closeModal(instance, addSamlProfileFormScope);
				}
			};
		}

		function addMetadataSp() {
			var url = String.format(URLS.metadataSpURL, globalConfig.customer.safeId);
			return url;
		}

		function disableSamlProfile(samlProfileId) {
			var confirmScope = $scope.$new();
			confirmScope.prefixText = 'Action could fully disable SSO. ';
			confirmScope.additionalText = ' disable this Profile';
			confirmScope.buttonText = 'Disable';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();

				configSSOService.disableSamlProfile(samlProfileId).then(function (message) {
					var toastMessage = '';
					var isSuccessful = false;
					if (_.isString(message)) {
						toastMessage = message;
						isSuccessful = true;
						$scope.$broadcast('reloadTable');
					}

					$rootScope.$emit('toast', {
						'message': toastMessage,
						'success': isSuccessful
					});
				});
			};
		}

		function deleteSamlProfile(samlProfileId) {
			configSSOService.getSamlProfile(samlProfileId).then(function (samlProfile) {
				var confirmScope = $scope.$new();
				if (samlProfile.isActive) {
					confirmScope.prefixText = 'Action could fully disable SSO. ';
				}
				confirmScope.additionalText = ' delete this Profile';
				confirmScope.buttonText = 'Delete';
				var opts = {
					scope: confirmScope,
					templateUrl: '/application/f/core/confirm.html'
				};


				var instance = $uibModal.open(opts);
				confirmScope.closeDialog = function () {
					instance.close();
					confirmScope.$destroy();
				};

				confirmScope.yes = function () {
					instance.close();
					confirmScope.$destroy();

					configSSOService.deleteSamlProfile(samlProfileId).then(function (message) {
						var toastMessage = '';
						var isSuccessful = false;
						if (_.isString(message)) {
							toastMessage = message;
							isSuccessful = true;
							$scope.$broadcast('reloadTable');
						}

						$rootScope.$emit('toast', {
							'message': toastMessage,
							'success': isSuccessful
						});
					});
				};
			});
		}

		function activateSamlProfile(samlProfileId) {
			configSSOService.activateSamlProfile(samlProfileId).then(function (message) {
				var toastMessage = '';
				var isSuccessful = false;
				if (_.isString(message)) {
					toastMessage = message;
					isSuccessful = true;
					$scope.$broadcast('reloadTable');
				}
				$rootScope.$emit('toast', {
					'message': toastMessage,
					'success': isSuccessful
				});
			});
		}

		function toggleLegacyEntityID(samlProfileId) {
			configSSOService.toggleLegacyEntityID(samlProfileId).then(function (message) {
				var toastMessage = '';
				var isSuccessful = false;
				if (_.isString(message)) {
					toastMessage = message;
					isSuccessful = true;
					$scope.$broadcast('reloadTable');
				}
				$rootScope.$emit('toast', {
					'message': toastMessage,
					'success': isSuccessful
				});
			});
		}

		init();
	}
})();
